import { AxiosError, AxiosRequestConfig } from 'axios';
import {
  IAssignTag,
  IBasicProductsCare,
  IBussinesDetail,
  ICreditOrganization,
  IListingFilters,
  IDeleteTagOrganziation,
  ISpecialBusinessNameTypes,
  ITagName,
  ITags,
  IUpdateSpecialBusinessNameBody,
  IUpdateSusbcriptions,
  IorganizationBusinessData,
  organizationCommercialPreferenceCreateDto,
  IEmailInvitation,
  Iorganization,
  IUpdateOrganizationType,
  ICountriesData,
  IOrganizationCreditResponse
} from '../types/bussines';
import { apiDelete, apiGet, apiPost, apiPut } from './api';

const { REACT_APP_ORGANIZATION, REACT_APP_SUBSCRIPTION } = process.env;

const listOrganizations = async (): Promise<Iorganization[]> => {
  return apiGet<AxiosRequestConfig, Iorganization[]>(`${REACT_APP_ORGANIZATION}/organization`)
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

const getBussinesList = async (searhText?: string, bussinesFiltersString?: string): Promise<IBussinesDetail[]> => {
  return apiGet<AxiosRequestConfig, IBussinesDetail[]>(
    `${REACT_APP_ORGANIZATION}/organization/backoffice/listing${searhText ? `?find=${searhText}` : ''}${bussinesFiltersString || ''
    }`
  )
    .then(resp => {
      const pillsList: IBussinesDetail[] = resp;
      return pillsList;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

const activatePaymentAgreement = async (body: ICreditOrganization) => {
  return apiPost<AxiosRequestConfig, ICreditOrganization>(
    `${REACT_APP_ORGANIZATION}/organization-commercial-preferences`,
    body
  )
    .then(resp => {
      const respEdit: string = resp;
      return respEdit;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

const deactivateCredit = async (
  organizationId: number | string,
  commercialPreferenceTypeUuid: string
): Promise<string> => {
  return apiDelete<AxiosRequestConfig, string>(
    `${REACT_APP_ORGANIZATION}/organization-commercial-preferences/${organizationId}/${commercialPreferenceTypeUuid}`
  )
    .then(resp => {
      const respEdit: string = resp;
      return respEdit;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

const getOrganizationData = async (organizationId: number | string): Promise<IorganizationBusinessData> => {
  return apiGet<AxiosRequestConfig, IorganizationBusinessData>(
    `${REACT_APP_ORGANIZATION}/organization/backoffice-ops/detail/${organizationId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const getSpecialBusinessNameTypes = async () => {
  return apiGet<AxiosRequestConfig, ISpecialBusinessNameTypes>(
    `${REACT_APP_ORGANIZATION}/special-business-name-type/backoffice`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateSpecialBusinessNameType = async (data: IUpdateSpecialBusinessNameBody) => {
  return apiPut<AxiosRequestConfig, IUpdateSpecialBusinessNameBody>(
    `${REACT_APP_ORGANIZATION}/organization/backoffice/billing-data/special-case`,
    data
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const getOrganizationInventoryURL = async (organizationId: number | string, filters?: string): Promise<string> => {
  const query = filters ? `?filters=${encodeURIComponent(filters)}` : '';
  return apiGet<string, string>(`${REACT_APP_SUBSCRIPTION}/query-tools/download-inventory/${organizationId}${query}`)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch((error: AxiosError) => {
      Promise.reject(error);
      throw error;
    });
};

const updateBillingDataByCountry = async (organizationId: string | number, formData: FormData) => {
  return apiPost<AxiosRequestConfig, FormData>(
    `${REACT_APP_ORGANIZATION}/organization/backoffice/billing-data/${organizationId}`,
    formData
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateOrganizationAdmin = async (userId: number | string, organizationId: number | string): Promise<unknown> => {
  return apiPut<AxiosRequestConfig, unknown>(
    `${REACT_APP_ORGANIZATION}/organization/backoffice/update-admin/${userId}?organizationId=${organizationId}`
  )
    .then(response => Promise.resolve(response || 200))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateSubscription = async (
  organizationId: number,
  body: IUpdateSusbcriptions
): Promise<IUpdateSusbcriptions> => {
  return apiPut<AxiosRequestConfig, IUpdateSusbcriptions>(
    `${REACT_APP_ORGANIZATION}/platform-subscription/update/${organizationId}`,
    body
  )
    .then(response => Promise.resolve(response || 200))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateOrganizationType = async (organizationId: number, body: IUpdateOrganizationType) => {
  return apiPut<AxiosRequestConfig, IUpdateOrganizationType>(
    `${REACT_APP_ORGANIZATION}/organization/backoffice/organization-type/${organizationId}`,
    body
  )
    .then(response => Promise.resolve(response || 200))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateCare = async (body: IBasicProductsCare[]): Promise<unknown> => {
  return apiPut<AxiosRequestConfig, unknown>(`${REACT_APP_SUBSCRIPTION}/product-care/care-update`, body)
    .then(response => Promise.resolve(response || 200))
    .catch((error: AxiosError) => Promise.reject(error));
};

const createNewOrganizationCommercialPreference = async (body: organizationCommercialPreferenceCreateDto) => {
  return apiPost<AxiosRequestConfig, organizationCommercialPreferenceCreateDto>(
    `${REACT_APP_ORGANIZATION}/organization-commercial-preferences`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const getListingFilters = async (): Promise<IListingFilters> => {
  return apiGet<AxiosRequestConfig, IListingFilters>(
    `${REACT_APP_ORGANIZATION}/organization/backoffice/listing/filters`
  ).then(resp => {
    const pillsList: IListingFilters = resp;
    return pillsList;
  });
};
const createTag = async (body: ITagName) => {
  return apiPost<AxiosRequestConfig, ITagName>(`${REACT_APP_ORGANIZATION}/organization/backoffice/tag/create`, body)
    .then(response => Promise.resolve(response?.data as ITags))
    .catch((error: AxiosError) => Promise.reject(error));
};

const deleteTag = async (uuid: string) => {
  return apiDelete<AxiosRequestConfig, string>(`${REACT_APP_ORGANIZATION}/organization/backoffice/tag/delete/${uuid}`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const assignTag = (body: IAssignTag) => {
  return apiPost<AxiosRequestConfig, IAssignTag>(`${REACT_APP_ORGANIZATION}/organization/backoffice/tag/assign`, body)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const deleteTagOrganziation = async (body: IDeleteTagOrganziation) => {
  return apiDelete<AxiosRequestConfig, IDeleteTagOrganziation>(
    `${REACT_APP_ORGANIZATION}/organization/backoffice/tag/unassign/${body.organizationId}/${body.organizationsTagId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const sendEmailInvitation = async (body: IEmailInvitation) => {
  return apiPost<AxiosRequestConfig, IEmailInvitation>(`${REACT_APP_ORGANIZATION}/organization/request-mail`, body)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const getBillingDataByOrganization = async (organizationId: string | number) => {
  return apiGet<AxiosRequestConfig, ICountriesData>(
    `${REACT_APP_ORGANIZATION}/organization/billing-data/by-organization/${organizationId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const getOrganizationCredit = async (organizationId: string | number) => {
  return apiGet<AxiosRequestConfig, IOrganizationCreditResponse>(
    `${REACT_APP_ORGANIZATION}/organization/credit/${organizationId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export {
  listOrganizations,
  getBussinesList,
  activatePaymentAgreement,
  deactivateCredit,
  getOrganizationData,
  updateBillingDataByCountry,
  updateOrganizationAdmin,
  updateSubscription,
  updateCare,
  getOrganizationInventoryURL,
  getSpecialBusinessNameTypes,
  updateSpecialBusinessNameType,
  createNewOrganizationCommercialPreference,
  getListingFilters,
  createTag,
  deleteTag,
  assignTag,
  deleteTagOrganziation,
  sendEmailInvitation,
  updateOrganizationType,
  getBillingDataByOrganization,
  getOrganizationCredit
};
